// components/BalancePage.tsx
import { useState } from "react";
import { format } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useBalancesByCurrencyRange } from "@/hooks/useBalance";
import { Empty } from "@/components/Empty";
import CreateAccount from "./account/Create";

export function BalancePage() {
  const [dateRange, setDateRange] = useState<{ from: Date; to: Date }>({
    from: new Date("2020-01-01"), // inicio del año
    to: new Date(),
  });
  const [open, setOpen] = useState(false);

  const { balances, loading } = useBalancesByCurrencyRange(
    format(dateRange.from, "yyyy-MM-dd"),
    format(dateRange.to, "yyyy-MM-dd")
  );
  const limpiar = (val: any) => {
    setOpen(val);
    // setEditAccount(null);
  };

  return (
    <div className="w-full mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold mr-4">Balance </h1>
        {/* <Popover>
          <PopoverTrigger asChild>
            <button className="p-2 px-5 rounded-lg border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50">
              {format(dateRange.from, "dd MMM yyyy")} -{" "}
              {format(dateRange.to, "dd MMM yyyy")}
            </button>
          </PopoverTrigger>
          <PopoverContent>
            <Calendar
              mode="range"
              selected={dateRange}
              onSelect={(range) => {
                if (range?.from && range?.to) {
                  setDateRange({ from: range.from, to: range.to });
                }
              }}
            />
          </PopoverContent>
        </Popover> */}
      </div>
      {loading ? (
        <p>Cargando balances...</p>
      ) : (
        <>
          {Object.entries(balances).length === 0 ? (
            <Empty
              title="Bienvenido a Finanza.lat"
              message="Aún no tienes cuentas registradas."
            >
              <CreateAccount
                open={open}
                setOpen={limpiar}
                limpiar={limpiar}
              ></CreateAccount>
            </Empty>
          ) : (
            <div className="max-w-3xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-5">
              {Object.entries(balances).map(([currency, accounts]) => {
                const total = accounts.reduce(
                  (acc, a) => acc + Number(a.balance),
                  0
                );
                return (
                  <Card key={currency} className="mb-4">
                    <CardHeader>
                      <h2 className="text-lg font-semibold">{currency}</h2>
                    </CardHeader>
                    <CardContent className="space-y-2">
                      {accounts.map((a) => (
                        <div
                          key={a.account_id}
                          className="flex justify-between"
                        >
                          <span>{a.account_name}</span>
                          <span>{Number(a.balance).toFixed(2)}</span>
                        </div>
                      ))}
                      <div className="flex justify-between font-semibold border-t pt-2">
                        <span>Total</span>
                        <span>
                          {total.toFixed(2)} {currency}
                        </span>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}
        </>
      )}
    </div>
  );
}
